import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type WLVocabularyOverusedWordsAnalyserRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/vocabulary/overused-words-analyser/route'

export default class WLVocabularyOverusedWordsAnalyserController extends Controller<
  ModelFor<WLVocabularyOverusedWordsAnalyserRoute>
> {
  queryParams = ['word']

  @tracked word = ''
}
